import React, { Component } from 'react';

//components
import Field from '../../Common/Field/Field'
import Button from '../../Buttons/Button'

//services 
import { DevelopmentServices } from '../../../services'

export default class Print extends Component {
    state = {

    }
    componentDidMount(){
        if(this.props.scroll){
            var printEle = document.getElementById('printId')
            printEle.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        }
    }

    updateValue = (name, value) => {
        this.props.getPrint('print', name, value)
    }

    createPrint = (e) => {
        e.preventDefault()
        let print = {...this.props.print}
        print.actionedBy = null

        let data ={
            print : print,
            toggle : {...this.props.toggle},
            _id : this.props._id,
        }

        DevelopmentServices.createPrint(data).then(response => {
            if(response.status === 200){
                this.props.getalertMessage('success',' Print Created ')
            }
            response.status === 401 && this.props.unauthorisedFunc()
        })
    }

    render() {

        const { fabricInfo, actionedByOption, print, disabled } = this.props

        return (
            <div className="col-md-12 px-5" id='printId' >
                <h6 className="text-green font-lg font-weight-bold">Print</h6>
                <div className="col-md-12 product-form px-0">
                    <div className='col-md-12 nopadding'>
                        <div className="col-md-2 step-one pr-0">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='actionedBy'
                                value = {fabricInfo && fabricInfo.PRINT && fabricInfo.PRINT.ASSIGNEDTO && fabricInfo.PRINT.ASSIGNEDTO.length > 0 && fabricInfo.PRINT.ASSIGNEDTO[0].value}
                                options={fabricInfo.PRINT && fabricInfo.PRINT.ASSIGNEDTO ? fabricInfo.PRINT.ASSIGNEDTO : []}
                                label='Assigned To'
                                onChange={this.updateValue}
                                disabled={true}
                            />
                        </div>
                      
                        <div className="col-md-2 step-one">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='printType'
                                value = {print.printType}
                                options={fabricInfo.PRINTTYPE || []}
                                label='Print Type'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-2 step-one">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='printDirection'
                                value = {print.printDirection}
                                options={fabricInfo.PRINTDIRECTION || []}
                                label='Print Direction'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-2 step-one">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='printRoute'
                                value = {print.printRoute}
                                options={fabricInfo.PRINTROUTE || []}
                                label='Print Route'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-2 step-one pr-0">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='noOfColors'
                                value = {print.noOfColors}
                                options={fabricInfo.NOOFCOLOURS}
                                label='No Of Colors'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 nopadding">
                        <div className="col-md-2 step-one pr-0">
                            <Field
                                isFormGroup={true}
                                inputType='text'
                                inputName='rotaryRepeatSize'
                                value = {print.rotaryRepeatSize}
                                label='Rotary Repeat Size'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 nopadding">
                        <div className="col-md-2 step-one pr-0">
                            <Field
                                isFormGroup={true}
                                inputType='checkboxToggle'
                                inputName='layerFile'
                                label='Layer File'
                                value={print.layerFile}
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-3 step-one pr-0">
                            <Field
                                isFormGroup={true}
                                inputType='checkboxToggle'
                                inputName='artworkWithColSquare'
                                label='Artwork wit col square'
                                value={print.artworkWithColSquare}
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-2 step-one pr-0">
                            <Field
                                isFormGroup={true}
                                inputType='checkboxToggle'
                                inputName='fluroscentCols'
                                label='Fluroscent cols'
                                value={print.fluroscentCols}
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 profile-btn text-center">
                        <Button
                            buttonName='Save'
                            onClick={this.createPrint}
                        />
                        <Button
                            buttonName='Cancel'
                            buttonType = 'cancel'
                            history ={this.props.history}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

Print.propTypes = {

};

Print.defaultProps = {

}


// WEBPACK FOOTER //
// ./src/components/Fabric/Print/Print.js